export default {
  'readOnly': ['IN_PREPARATION', 'SENT'],
  'writable': ['NEW'],
  'onSetBackToList': ['IN_PREPARATION']
};
